import { Box, Typography, IconButton } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useLocation, useNavigate } from 'react-router-dom'
import UserLayout from '../../layouts/UserLayout'

const Orders = () => {
	const location = useLocation()
	const navigate = useNavigate()

	const { userOrders } = location.state || {}

	const orders = userOrders || []

	const handleOrderClick = (order) => {
		navigate(`/admin/zalo-mini-app/order-detail/${order.id}`)
	}

	return (
		<UserLayout>
			<Box
				sx={{
					background: '#f5f5f5',
					minHeight: '100vh',
					paddingBottom: '60px',
				}}>
				{/* Header */}
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 2,
						p: 2,
						background: '#fff',
						borderBottom: '1px solid #e0e0e0',
						position: 'sticky',
						top: 0,
						zIndex: 1000,
					}}>
					<IconButton onClick={() => navigate(-1)} sx={{ color: '#000' }}>
						<ArrowBackIcon />
					</IconButton>
					<Typography
						sx={{
							fontSize: '20px',
							fontWeight: 500,
							flex: 1,
							textAlign: 'left',
						}}>
						Đơn hàng
					</Typography>
				</Box>

				{/* Orders List */}
				{(orders?.length ?? 0) === 0 ? (
					<Box sx={{ p: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<Typography sx={{ fontSize: '16px', fontWeight: 500 }}>Không có đơn hàng</Typography>
					</Box>
				) : null}

				<Box sx={{ p: 2 }}>
					{orders.map((orderData, index) => {
						const order = orderData.order // Lấy thông tin đơn hàng từ trường order
						return (
							<Box
								key={index}
								sx={{
									background: '#fff',
									borderRadius: '8px',
									mb: 2,
									overflow: 'hidden',
									cursor: 'pointer',
								}}
								onClick={() => handleOrderClick(order)}>
								<Box
									sx={{
										display: 'flex',
										p: 2,
										gap: 2,
									}}>
									<Box
										component='img'
										src={order.line_items?.[0]?.image || 'default-image-url.jpg'}
										sx={{
											width: 80,
											height: 80,
											objectFit: 'cover',
											borderRadius: '4px',
										}}
									/>
									<Box sx={{ flex: 1 }}>
										<Box
											sx={{
												display: 'flex',
												justifyContent: 'space-between',
												mb: 1,
											}}>
											<Typography
												sx={{
													fontSize: '14px',
													color: '#666',
												}}>
												{order.date_created}
											</Typography>
											<Typography
												sx={{
													fontSize: '16px',
													fontWeight: 500,
												}}>
												{order.total?.toLocaleString()}đ
											</Typography>
										</Box>
										<Box
											sx={{
												display: 'flex',
												flexDirection: { xs: 'column', sm: 'row' }, // Stack dọc trên mobile, ngang trên desktop
												gap: 0.5,
											}}>
											<Typography sx={{ fontSize: '14px' }}>Mã đơn hàng:</Typography>
											<Typography
												sx={{
													fontSize: '14px',
													wordBreak: 'break-word',
													overflowWrap: 'break-word',
												}}>
												{order.id}
											</Typography>
										</Box>
										<Typography
											sx={{
												fontSize: '14px',
												color: '#666',
											}}>
											{order.line_items?.length || 0} sản phẩm
										</Typography>
									</Box>
								</Box>
							</Box>
						)
					})}
				</Box>
			</Box>
		</UserLayout>
	)
}

export default Orders
